<template>
    <div v-if="showsWidgets" class="flex flex-col gap-1">
        <component :is="tag" v-for="tag in extensions" :key="tag" />
        <TrustedShopsWidget location="product_name" :sku="productStore.configurableProduct.group_identifier" :gtin="gtin" />
    </div>
</template>

<script setup lang="ts">
import TrustedShopsWidget from '@/components/reviews/TrustedShopsWidget.vue';
import { loadEtrustedWidgetScript } from '@/lib/trustedShops';
import { useProductPageStore } from '@/stores/pages/ProductPageStore';
import { useProductStore } from '@/stores/products/ProductStore';
import type { AppPageProps } from '@/types';
import { usePage } from '@inertiajs/vue3';
import { computed, onMounted } from 'vue';

const page = usePage<AppPageProps>();
const productPageStore = useProductPageStore();
const productStore = useProductStore();

const extensions = computed(() => page.props.trusted_shops?.product_page_extensions ?? []);
const gtin = computed(() => productStore.configurableProduct.default_configurable_product_product?.metadata?.ean ?? null);

// Server-rendered Trusted Shops reviews already put their stars by the title.
const showsWidgets = computed(
    () => !productPageStore.trustedShopsReviews && (extensions.value.length > 0 || !!page.props.trusted_shops?.widgets.product_name),
);

onMounted((): void => {
    if (showsWidgets.value && extensions.value.length > 0) {
        loadEtrustedWidgetScript();
    }
});
</script>
